import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import Button from "@/components/wpl/button/src";
import { useLocalizedHref } from "@/libraries/web-framework";

const containerStyle = css({
    boxSizing: "border-box",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    maxWidth: "1200px",
    padding: "16px",
    fontFamily:
        "Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif"
});

const innerContainerStyle = css({
    alignContent: "flex-start",
    boxSizing: "border-box",
    display: "flex",
    flexBasis: "0%",
    flexGrow: "2",
    flexShrink: "1",
    flexWrap: "wrap",
    maxWidth: "628px",
    minWidth: "50%"
});

const textContainer = css({
    marginBlockStart: "5px",
    marginBlockEnd: "3px",
    fontSize: "20px",
    fontWeight: "400",
    letterSpacing: "0.3px",
    lineHeight: "28px",
    verticalAlign: "baseline",
    color: "#42526e"
});

const buttonStyle = css({
    margin: `${token("space.0")} ${token("space.0")} ${token(
        "space.200"
    )} ${token("space.0")}`,
    fontWeight: "500",
    minHeight: 40,
    textWrap: "wrap",
    verticalAlign: "baseline",
    whiteSpaceCollapse: "collapse",
    fontFamily: "var(--bxp-charlie-text-font-family)",
    marginBlockEnd: "24px"
});

const buttonContainer = css({
    marginBlockStart: "40px"
});

const TechnicalSupport = () => {
    const intl = useIntl();
    const contactSupportText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.techical-support.contact-support",
        defaultMessage: "Contact support"
    });

    const supportServiceText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.techical-support.support-service",
        defaultMessage: ` If your question is related to purchasing additional support services, select “product features” or “pricing & quotes”.`
    });
    const assistanceText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.techical-support.assistance",
        defaultMessage:
            "For assistance with a service you already pay for, please raise a support ticket."
    });

    return (
        <div css={containerStyle}>
            <div css={innerContainerStyle}>
                <div css={textContainer}>
                    <p>{supportServiceText}</p>
                    <p>{assistanceText}</p>
                </div>
                <p css={buttonContainer}>
                    <Button
                        text={contactSupportText}
                        aria-label={contactSupportText}
                        css={buttonStyle}
                        color="darkblue"
                        url={useLocalizedHref(
                            "/company/contact/purchasing-licensing"
                        )}
                        dataEventProps={{
                            "data-product-key": "jiraSoftwareFeature",
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-label": contactSupportText
                        }}
                    />
                </p>
            </div>
        </div>
    );
};

export default TechnicalSupport;
